import i18n from '@/lang';
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.promise.js";
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.object.assign.js";
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.promise.js";
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.object.assign.js";
import "G:\\SVN\\\u5355\u5C0F\u4E8C\\\u6E90\u4EE3\u7801\\\u5BA2\u6237\u7AEF\u95E8\u6237\\front\\smy-toc-vux-cli3\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from 'vue-router';
import i18n2 from './lang/index';
import FastClick from '@/utils/fastclick';
import router from './router';
import VueLazyload from 'vue-lazyload';
router.addRoute('Layout', {
  path: '/home',
  name: 'Home',
  component: function component() {
    return import('@/pages/home/entry');
  },
  meta: {
    name: i18n.tc("0")
  }
});
import store from './store';
import App from './App';
import getCode from './utils/getCode';
import ToastPlugin from "vux/src/plugins/toast/index.js"; // this line is trasformed by vux-loader
import LoadingPlugin from "vux/src/plugins/loading/index.js"; // this line is trasformed by vux-loader
import ConfirmPlugin from "vux/src/plugins/confirm/index.js"; // this line is trasformed by vux-loader
import XDialog from "vux/src/components/x-dialog/index.vue"; // this line is trasformed by vux-loader
import DatetimePlugin from "vux/src/plugins/datetime/index.js"; // this line is trasformed by vux-loader
import { Toast } from 'vant';
import vConsole from 'vconsole';
import installActionSheet from '@/utils/installActionSheet.js';
import vue2PhotoPreview from 'vue2-photo-preview';
import 'vue2-photo-preview/dist/style.css';
if (new URLSearchParams(location.search).get('isDebug')) {
  new vConsole();
}
import TpLoadingBar from '@/components/TpLoadingBar/install';
import { decode } from 'html-entities';
// Vue.use(wxConfig)
var loadimage = require('@/assets/icon/loading.png');
var errorimage = require('@/assets/icon/loading.png');
Vue.use(vue2PhotoPreview);
Vue.use(installActionSheet);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
});
Vue.use(TpLoadingBar); // loadingBar
Vue.use(LoadingPlugin);
Vue.use(DatetimePlugin);
Vue.use(ToastPlugin, {
  position: 'middle'
});
Vue.use(ConfirmPlugin);
Vue.use(XDialog);
Vue.use(VueRouter);
Vue.use(getCode);
Vue.use(Toast);
var androidBack = function androidBack(event) {
  var config = store.state.globalStore.androidBack;
  if (Object.keys(config).length > 0 && config.control) {
    config.onSuccess();
    event.preventDefault(); // 阻止默认的回退行为
  }
};
Vue.prototype.$decodeHtml = function (value) {
  if (!value) return '';
  return decode(value);
};
Vue.prototype.$showUserName = function () {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /\$userName=/.test(str) ? false : true;
};
Object.defineProperty(Vue.prototype, '$env', {
  get: function get() {
    return {
      /**
       * @description 判断是否为企业微信环境
       */
      isWx: process.env.VUE_APP_TYPE === 'wx'
    };
  }
});
Vue.prototype.pickerFcous = function () {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  // eslint-disable-next-line
  isiOS ? window.scrollTo(0, 1000) : null;
};
Vue.prototype.$setBackbuttonListen = function () {
  document.addEventListener('backbutton', androidBack, false);
};
Vue.prototype.$showName = function (item) {
  item = item || '';
  var value = item.slice(item.lastIndexOf('/') + 1);
  return /\d+-.+/.test(value) ? value.split('-').slice(1).join('-') : value;
};
// 设置钉钉左侧按钮
// Vue.prototype.$setLeft = (config) => {
//   if (store.state.globalStore.RUN_ENV === 'Android') {
//     store.commit('globalStore/_androidBack', config)
//   } else if (store.state.globalStore.RUN_ENV === 'ios') {
//     if (Vue.prototype.$DingTalk) {
//       if (config.control) {
//         Vue.prototype.$DingTalk.biz.navigation.setLeft({
//           control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
//           text: config.text || '返回', // 控制显示文本，空字符串表示显示默认文本
//           onSuccess: (result) => {
//             config.onSuccess()
//           },
//           onFail: (e) => {}
//         })
//       } else {
//         Vue.prototype.$DingTalk.biz.navigation.setLeft({
//           control: false
//         })
//       }
//     }
//   }
// }

FastClick.attach(document.body);
Vue.config.productionTip = false;
// Vue.prototype.$http = request

/* eslint-disable no-extend-native */
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'D+': this.getDate(),
    'H+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds()
  };
  if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }
  return fmt;
};
Vue.mixin({
  data: function data() {
    return {
      backChange: null
    };
  },
  destroyed: function destroyed() {
    if (this.backChange) {
      window.removeEventListener('popstate', this.backChange, false);
    }
  },
  methods: {
    $setLeft: function $setLeft(config) {
      try {
        this.backChange = config.onSuccess || function noop() {};
        if (config.control) {
          history.pushState(null, null, document.URL);
          window.addEventListener('popstate', this.backChange, false);
        } else {
          window.removeEventListener('popstate', this.backChange, false);
          this.backChange = null;
        }
      } catch (error) {
        console.log('AutoConsole: noop -> error', error);
      }
    }
  }
});
/* eslint-disable no-new */
new Vue({
  router: router,
  store: store,
  i18n: i18n2,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app-box');